import type { ReleaseLog } from './release'

const terms = (query:string):string[] => Array.from(new Set(query.trim().toLowerCase().split(/\s+/).filter(Boolean)))

// 多个关键词可分别命中版本号、标题和不同更新项；保持接口原顺序及原始内容。
export function filterReleaseLogs(logs:ReleaseLog[], query:string):ReleaseLog[] {
  const keywords=terms(query)
  if(!keywords.length)return logs
  return logs.filter(log=>{
    const text=[`V${log.version}`,log.title,...log.changes].join('\n').toLowerCase()
    return keywords.every(keyword=>text.includes(keyword))
  })
}

export function highlightReleaseText(value:string, query:string):Array<{text:string;matched:boolean}> {
  const text=String(value ?? ''),keywords=terms(query).sort((a,b)=>b.length-a.length)
  if(!keywords.length)return [{text,matched:false}]
  const expression=new RegExp(keywords.map(keyword=>keyword.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')).join('|'),'gi')
  const parts:Array<{text:string;matched:boolean}>=[]
  let cursor=0,match:RegExpExecArray|null
  while((match=expression.exec(text))!==null){
    if(match.index>cursor)parts.push({text:text.slice(cursor,match.index),matched:false})
    parts.push({text:match[0],matched:true});cursor=match.index+match[0].length
  }
  if(cursor<text.length || !parts.length)parts.push({text:text.slice(cursor),matched:false})
  return parts
}
